import React  from 'react';
import './Header.css';

export default function Header({ onSelectWeek, selectedWeek }) {
  return (
      <header className="header">
        <div className="logo">Snackstrology</div>
        <nav className="nav">
          <button
              className={selectedWeek === 'previous' ? 'active' : ''}
              onClick={() => onSelectWeek('previous')}
          >
            Previous Week
          </button>
          <button
              className={selectedWeek === 'current' ? 'active' : ''}
              onClick={() => onSelectWeek('current')}
          >
            Current Week
          </button>
          <button disabled>Next Week</button>
        </nav>
      </header>
  );
}